import { render, staticRenderFns } from "./new_quote.vue?vue&type=template&id=4379dea4"
import script from "./new_quote.vue?vue&type=script&lang=js"
export * from "./new_quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports